import httpService from "../../components/service";
const STATUS = {
    opened: 1,
    closed: 2
};
export const comment = {
    namespaced: true,
    state: {
        data: undefined,
        allComments: [],
        status: undefined
    },
    getters: {
        comments: state => state.allComments.filter(comment => comment.isPersonal === false),
        data: state => state.data,
        personalNotes: state => state.allComments.filter(comment => comment.isPersonal === true),
        commentsLength: state => state.allComments.length || 0,
        status: state => state.status
    },
    mutations: {
        POPULATE_ALL_COMMENTS(state, comments) {
            state.allComments = comments;
        },
        SET_DATA(state, data) {
            state.data = data;
        },
        ADD_COMMENT(state, comment) {
            state.allComments.unshift(comment);
        },
        REMOVE_COMMENT(state, commentId) {
            const commentIndex = state.allComments.findIndex(comment => comment.id === commentId);
            state.allComments.splice(commentIndex, 1);
        },
        SET_STATUS(state, status) {
            state.status = status;
        }
    },
    actions: {
        async populate({ commit }, data) {
            const res = await httpService.get("/app/" + data.appId + "/comments-list?" + data.params);
            if (res.code) throw new Error(res.message);
            commit("SET_DATA", data.params);
            commit("POPULATE_ALL_COMMENTS", res.data);
        },
        async fetchStatus(context) {
            if (!context.state.status) {
                const response = await httpService.get("/comment/all-status-list");
                let status = {};
                status.openStatus = response.find(element => {
                    return element.id === STATUS.opened;
                });
                status.closeStatus = response.find(element => {
                    return element.id === STATUS.closed;
                });
                context.commit("SET_STATUS", status);
            }
        },
        updateCommentS: (context, data) => {
            return new Promise((resolve, reject) => {
                httpService
                    .put("/comment/" + data.comment.id + "/update", JSON.stringify(data.comment))
                    .then(response => {
                        resolve(true);
                    })
                    .catch(e => {
                        reject(e);
                    });
            });
        },
        async removeCommentS({ commit }, id) {
            const res = await httpService.delete("/comment/" + id + "/delete");
            if (res.code) throw Error(res.message);
            commit("REMOVE_COMMENT", id);
        },
        async saveNewComment(context, data) {
            const res = await httpService.post("/app/" + data.appId + "/comment", JSON.stringify(data.comment));
            if (res.code) throw Error(res.message);
            context.commit("ADD_COMMENT", res);
        },
        flushComment({ commit }) {
            setTimeout(() => commit("POPULATE_ALL_COMMENTS", []), 10);
            commit("SET_DATA", undefined);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/comment/comment.js